<template>
  <div
    class="license-app"
    style="margin-left: 5%;margin-right: 5%;overflow: auto;"
  >
    <el-container>
      <el-main>
        <div style="text-align:left" v-if="isShowReturn">
          <el-form :inline="true" :model="filterForm">
            <el-form-item label="申请人：">
              <el-input
                placeholder="申请人"
                v-model="filterForm.applicant"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="目标客户：">
              <el-input
                placeholder="目标客户"
                v-model="filterForm.target_customer"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="授权功能code：">
              <!-- <el-input
                placeholder="授权功能code"
                v-model="filterForm.feature_code"
                clearable
              ></el-input> -->
              <el-select
                v-model="filterForm.feature_code"
                placeholder="授权功能code"
                clearable
              >
                <el-option
                  v-for="item in featureItems"
                  :label="item.label"
                  :value="item.code"
                  :key="item.value"
                >
                  <span style="float: left">{{ item.label }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{
                    item.code
                  }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleSearch">查询</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div>
          <el-table
            :data="
              isShowReturn
                ? tableData
                : tableData.slice(
                    (currentPage - 1) * pagesize,
                    currentPage * pagesize
                  )
            "
            border
            :default-sort="{ prop: 'create_timestamp', order: 'descending' }"
            style="width: 100%"
            @filter-change="filterHandler"
            @sort-change="sortHandler"
          >
            <el-table-column
              v-for="col in tableHeader"
              :prop="col.prop"
              :label="col.label"
              :width="col.width"
              :key="col.prop"
              :formatter="col.formatter"
              :filters="col.filters"
              :filterMethod="col.filterMethod"
              :sortable="col.sortable"
              :column-key="col.columnKey"
            >
              <template v-for="operate of col.operate" slot-scope="scope">
                <el-button
                  :key="operate.name"
                  :type="operate.type === 'return' ? 'primary' : 'success'"
                  size="mini"
                  @click="btnHandle(operate.type, scope)"
                >
                  {{ operate.name }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-main>
      <el-footer>
        <el-row>
          <el-col :span="20">
            <div class="pagination">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 20, 40]"
                :page-size="pagesize"
                layout="total, sizes, prev, pager, next"
                :total="isShowReturn ? total : tableData.length"
                prev-text="上一页"
                next-text="下一页"
                style="margin: auto;"
              >
              </el-pagination>
            </div>
          </el-col>
          <el-col :span="4">
            <el-button v-show="isShowReturn" @click="getLic">返回</el-button>
          </el-col>
        </el-row>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import axios from "axios";
import { dateFormat } from "@/libs/date.js";

export default {
  name: "License",
  data() {
    return {
      currentPage: 1, //默认显示页面为1
      pagesize: 10, //    每页的数据条数
      tableData: [],
      tableHeader: [],
      isShowReturn: false,
      tableLicense: [
        { prop: "username", label: "用户" },
        { prop: "status_num_all", label: "总授权量" },
        { prop: "status_num_2", label: "已分配已授权量" },
        { prop: "status_num_1", label: "已分配未授权量" },
        { prop: "status_num_0", label: "未分配未授权量" },
        {
          prop: "userid",
          label: "操作",
          operate: [
            {
              type: "show",
              name: "查看",
            },
          ],
        },
      ],
      tableLicenseInfo: [
        { prop: "id", label: "授权码id" },
        {
          prop: "create_timestamp",
          label: "创建时间",
          width: 160,
          sortable: true,
        },
        { prop: "feature_code", label: "授权功能code", width: 120 },
        {
          prop: "activate_status",
          label: "是否激活",
          filters: [
            { text: "已激活", value: true },
            { text: "未激活", value: false },
          ],
          width: 100,
          columnKey: "activate_status",
        },
        {
          prop: "license_mode",
          label: "授权模式",
          formatter: (row) => {
            return row.license_mode === "1" ? "时间" : "用量";
          },
        },
        {
          prop: "license_time",
          label: "授权时长/用量",
          formatter: (row) => {
            if (row.license_mode === "1") {
              return row.duration === 0 ? "无限" : `${row.duration}天`;
            } else {
              if (row.capacity) {
                const count = row.capacity.slice(1);
                return row.capacity === -1
                  ? "无限"
                  : row.capacity[0] === "D"
                  ? `每天${count}次`
                  : `每周${count}次`;
              } else {
                return "";
              }
            }
          },
          width: 110,
        },
        { prop: "applicant", label: "申请人" },
        { prop: "target_customer", label: "目标客户" },
        { prop: "activate_timestamp", label: "激活时间", width: 160 },
        { prop: "expired_timestamp", label: "失效时间", width: 160 },
        { prop: "device_id", label: "激活设备唯一码", width: 120 },
        // {
        //   label: "返回",
        //   operate: [
        //     {
        //       type: "return",
        //       name: "返回"
        //     }
        //   ]
        // }
      ],
      total: 0,
      filterForm: {
        is_activated: undefined, //是否授权
        feature_code: "", //授权code
        order_by_time: "desc",
        applicant: "", //申请人
        target_customer: "", //目标客户
      },
      currentUserId: "",
      featureItems: [],
    };
  },
  methods: {
    dateTimeFormat(data) {
      return dateFormat("YYYY-mm-dd HH:MM:SS", new Date(Number(data * 1000)));
    },
    btnHandle(type, scope) {
      if (type === "show") {
        this.isShowReturn = true;
        this.listLicenseInfo(scope.row.userid);
      } else if (type === "return") {
        this.getLic();
      }
    },
    // 每页下拉显示数据
    handleSizeChange(size) {
      this.pagesize = size;
      this.currentPage = 1;
      if (this.isShowReturn) {
        this.listLicenseInfo(this.currentUserId);
      }
    },
    // 点击第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      if (this.isShowReturn) {
        this.listLicenseInfo(this.currentUserId);
      }
    },
    handleSearch() {
      this.currentPage = 1;
      this.listLicenseInfo(this.currentUserId);
    },
    listLicenseInfo(userid) {
      this.currentUserId = userid;
      const that = this;
      this.tableHeader = this.tableLicenseInfo;
      axios
        .get(`/api/license/lic_info/${userid}`, {
          params: {
            ...this.filterForm,
            page: this.currentPage,
            size: this.pagesize,
          },
        })
        .then((response) => {
          this.total = response.data.total || 0;
          try {
            this.tableData = (response.data.data || []).map(function(data) {
              if (data.create_timestamp)
                data.create_timestamp = that.dateTimeFormat(
                  data.create_timestamp
                );
              if (data.activate_timestamp) {
                data.activate_timestamp = that.dateTimeFormat(
                  data.activate_timestamp
                );
              }
              if (data.expired_timestamp) {
                data.expired_timestamp = that.dateTimeFormat(
                  data.expired_timestamp
                );
              }
              data.activate_status =
                Number(data.activate_status) === 2 ? "是" : "否";
              return data;
            });
          } catch (error) {
            console.log(error);
          }
        });
    },
    getLic() {
      axios.get("/api/license/lic_info").then((response) => {
        this.currentPage = 1;
        this.tableHeader = this.tableLicense;
        this.tableData = response.data;
        this.isShowReturn = false;
      });
    },
    filterHandler(filter) {
      const status = filter["activate_status"];
      if (status && status.length && status.length !== 2) {
        this.filterForm.is_activated = status[0];
      } else {
        this.filterForm.is_activated = undefined;
      }
      this.currentPage = 1;
      this.listLicenseInfo(this.currentUserId);
    },
    sortHandler({ order }) {
      if (order === "descending") {
        this.filterForm.order_by_time = "desc";
      } else {
        this.filterForm.order_by_time = "asc";
      }
      this.currentPage = 1;
      this.listLicenseInfo(this.currentUserId);
    },
    getFeatureItems() {
      axios.get("/api/license/feature/list").then((response) => {
        this.featureItems = response.data;
      });
    },
  },
  created() {
    this.tableHeader = this.tableLicense;
    this.getLic();
    this.getFeatureItems();
  },
};
</script>

<style scoped></style>
